import {NgModule} from '@angular/core';
import {InputNumberModule} from 'primeng/inputnumber';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {MultiSelectModule} from 'primeng/multiselect';
import {TooltipModule} from 'primeng/tooltip';
import {DropdownModule} from 'primeng/dropdown';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {InputTextComponent} from './input-text/input-text.component';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {InputEmailComponent} from './input-email/input-email.component';
import {InputDropdownComponent} from './input-dropdown/input-dropdown.component';
import {InputMultiselectComponent} from './input-multiselect/input-multiselect.component';
import {ChipModule} from 'primeng/chip';
import {InputNumberComponent} from './input-number/input-number.component';
import {InputMoneyComponent} from './input-money/input-money.component';
import {InputPasswordComponent} from './input-password/input-password.component';
import {InputFileUploadComponent} from "./input-file-upload/input-file-upload.component";
import {InputFileViewerComponent} from "./input-file-viewer/input-file-viewer.component";
import {FileUploadModule} from "primeng/fileupload";
import {CoreDirectiveModule} from "../directive/core-directive.module";
import {ImageModule} from "primeng/image";

@NgModule({
  declarations: [
    InputMoneyComponent,
    InputNumberComponent,
    InputTextComponent,
    InputEmailComponent,
    InputDropdownComponent,
    InputMultiselectComponent,
    InputPasswordComponent,
    InputFileUploadComponent,
    InputFileViewerComponent
  ],
  imports: [
    InputNumberModule,
    DropdownModule,
    MultiSelectModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    TooltipModule,
    FontAwesomeModule,
    FileUploadModule,
    CoreDirectiveModule,
    InputTextModule,
    ButtonModule,
    ChipModule,
    ImageModule
  ],
  exports: [
    InputMoneyComponent,
    InputNumberComponent,
    InputTextComponent,
    InputEmailComponent,
    InputDropdownComponent,
    InputMultiselectComponent,
    InputPasswordComponent,
    InputFileUploadComponent,
    InputFileViewerComponent
  ]
})
export class CoreInputModule {

}
